export const GENERAL = 0x0a01;
export const CHECK_BAD_URL_OR_BLOCK_COUNT = 0x0a02;
export const CHECK_ERROR_DOWNLOAD_OR_PARSE = 0x0a03;
export const START_NOT_FOUND_DATA = 0x0a04;
